const MainMenu = [
  {
    id: 1,
    name: 'Инфопанель',
    icon: 'fas fa-home',
    path: '/'
  },
  {
    id: 9702,
    name: 'Страницы',
    icon: 'fab fa-elementor pad3px',
    path: '/cms/pages'
  },
  {
    id: 9703,
    name: 'Контент',
    icon: 'fas fa-file-alt pad4px',
    path: '/cms/content'
  },
  {
    id: 9704,
    name: 'Блоки',
    icon: 'fas fa-th-large pad2px',
    path: '/cms/blocks'
  },
  {
    id: 9705,
    name: 'Меню',
    icon: 'fas fa-bars  pad4px',
    path: '/cms/menus'
  },
  {
    id: 9708,
    name: 'Пункты меню',
    icon: 'fas fa-bars  pad4px',
    path: '/cms/menusItems'
  },
  {
    id: 9709,
    name: 'Товары на сайте',
    icon: 'fas fa-tshirt',
    path: '/cms/ishopProducts'
  },
  {
    id: 9710,
    name: 'Медия',
    icon: 'fas fa-images',
    path: '/cms/media'
  },
  {
    id: 9701,
    name: 'Конфигурация',
    icon: 'fas fa-cogs',
    path: '/cms/config'
  },
  {
    id: 9706,
    name: 'Пользователи сайта',
    icon: 'fas fa-user-friends',
    path: '/cms/siteUsers'
  },
  {
    id: 9707,
    name: 'Администраторы',
    icon: 'fas fa-key pad2px',
    path: '/cms/adminPanelUsers'
  },
  {
    id: 99,
    name: 'Профиль',
    icon: 'fas fa-user-circle pad2px',
    path: '/profile'
  }
]

export default MainMenu



// WEBPACK FOOTER //
// ./src/components/MainMenu/mainMenuTemplateBASE.json.js